import * as React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { trackServiceClick } from './tracking';
import { openCianGptPopup } from './utils/openCianGptPopup';
import { splitIntoTwoColumns } from './utils/splitIntoTwoColumns';
import { AllServices } from '../../components/AllServices';
import { PageService } from '../../components/PageService';
import { Section } from '../../components/Section';
import { ServicesPageHeader } from '../../components/ServicesPageHeader';
import { AUD_MOBILE_REDESIGN_MAINPAGE } from '../../constants/experiments';
import { selectExperiments } from '../../selectors/experiments';
import { selectPageServices } from '../../selectors/pageServices';
import { getExperiment, isExperimentActive } from '../../utils/experiments';

export const ServicesPage: React.FC = () => {
  const services = useSelector(selectPageServices);
  const experiments = useSelector(selectExperiments);
  const isInRedesignGroup = isExperimentActive(experiments, AUD_MOBILE_REDESIGN_MAINPAGE, 'B');
  const hasExperimentData = Boolean(getExperiment(experiments, AUD_MOBILE_REDESIGN_MAINPAGE));

  useEffect(() => {
    if (hasExperimentData && !isInRedesignGroup) {
      window.location.replace('/');
    }
  }, [hasExperimentData, isInRedesignGroup]);

  const handleClick = (key: string) => {
    return (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (key === 'chat_bot') {
        event.preventDefault();
        openCianGptPopup();
      }

      trackServiceClick(key);
    };
  };

  const serviceElements = services.map(service => (
    <PageService
      key={service.key}
      title={service.title}
      url={service.url}
      description={service.description}
      image={service.image ?? ''}
      onClick={handleClick(service.key)}
    />
  ));
  const [leftColumn, rightColumn] = splitIntoTwoColumns(serviceElements);

  if (hasExperimentData && !isInRedesignGroup) {
    return null;
  }

  return (
    <>
      <ServicesPageHeader returnUrl="/" />
      <Section indent="S" sideIndent="S">
        <AllServices leftColumn={leftColumn} rightColumn={rightColumn} />
      </Section>
    </>
  );
};
